module.exports = __webpack_public_path__ + "media/images/extermination_camp_new-b29150b1.svg";